import { isSameDay, parseJSON } from "date-fns";
import { Calendar, Box, Stack, Text } from "grommet";
import React from "react";

const MatchCalendar = ({ matchDays, selectedDay, onSelect }) => {
    return (
        <Calendar showAdjacentDays={"trim"} fill style={{ height: "400px" }} date={selectedDay} onSelect={(date) => onSelect(typeof date == "string" ? date : date[0])} animate={false}>
            {({ date, day, isInRange, isSelected }) => {
                const hasContent = matchDays?.some((d) => isSameDay(parseJSON(d), date));
                return (
                    <Box pad={"3px"} width="60px" height="60px">
                        <Box background={isSelected ? "brand" : "background"} fill pad={{ horizontal: "3px" }}>
                            <Stack anchor="center" fill>
                                <Text size="xsmall">{day}</Text>
                                {hasContent ? (
                                    <Text size="small" color={isSelected ? "background-back" : "brand"}>
                                        VS
                                    </Text>
                                ) : null}
                            </Stack>
                        </Box>
                    </Box>
                );
            }}
        </Calendar>
    );
};

export default MatchCalendar;
